import { render } from "./detailView.vue?vue&type=template&id=c325c85a"
import script from "./detailView.vue?vue&type=script&lang=js"
export * from "./detailView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gegeheusel/Sites/leica-partnersuche-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__